import React from 'react';
import { toast } from "react-toastify";

import ModalConfirmAction from '../../_other/ModalConfirmAction';
import AdminModalAddNewCompany from "./AdminModalAddNewCompany";

import {Button,ButtonToolbar,Form} from 'react-bootstrap'

import { serverService } from '../../../_services/server.service';

import './AdminCompaniesTable.css'

import moment from 'moment'

const $ = require('jquery');
$.DataTable = require('datatables.net');

require( 'datatables.net-bs4' );
require( 'datatables.net-select-bs4' );
require('../../datatables.selected.css');

const columns = [
    {
        title: 'Name',
        width: 70,
        data: 'Name'
    },
    {
        title: 'AutoPilot',
        width: 70,
        data: 'AutoPilot'
    },
    {
        title: 'Responsable',
        width: 70,
        data: 'ResponsableFirstName'
    },
    {
        title: 'Address',
        width: 70,
        data: 'Address'
    },
    {
        title: 'VAT',
        width: 70,
        data: 'VATNumber'
    },
    {
        title: 'Phone',
        width: 70,
        data: 'PhoneNumber'
    },
    {
        title: 'Email',
        width: 70,
        data: 'Email'
    },
    {
        title: 'Language',
        width: 70,
        data: 'Language'
    },
];


interface MyProps {
    companies:any,
    onCompanyAdded(extra:string):any,
    onCompanyEdited(extra:string):any,
    onCompanyDeleted():any,
}

interface MyState {
    submitted: boolean,
    modalAddNewShow:boolean,
    modalConfirmDeleteShow: boolean,
    selectedCompany: any,
    formFields:any,
}

class AdminCompaniesTable extends React.Component<MyProps,MyState> {
    constructor(props) {
        super(props);

        this.state = {
            submitted:false,
            modalAddNewShow:false,
            modalConfirmDeleteShow:false,
            formFields:{},
            selectedCompany:{}
        };


        this.onCompanyAdded = this.onCompanyAdded.bind(this);
        this.onCompanyEdited = this.onCompanyEdited.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentDidMount() {
        let table = $(this.refs.main).DataTable({
            dom: "<'data-table-wrapper'" +
                    "<'row'<'col-md-6'<'toolbar'>><'col-md-6'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>" +
                    ">",
            data: this.props.companies,
            columns,
            ordering: true,
            paging:true,
            scrollX: true,
            select: {
                style: 'single',
                //blurable: true
            },
            columnDefs: [
                { width: 70, targets: 0 },
                { width: 70, targets: 1 },
                { width: 70, targets: 2 },
                { width: 70, targets: 3 },
                { width: 70, targets: 4 },
                { width: 70, targets: 5 },
                { width: 70, targets: 6 },
                { width: 70, targets: 7 },
            ]
        });

        $("#deleteBtn").hide();
        $("#editBtn").hide();

        table.on( 'select', function ( e, dt, type, indexes ) {
            $("#deleteBtn").show();
            $("#editBtn").show();
        });

        table.on( 'deselect', function ( e, dt, type, indexes ) {
            $("#deleteBtn").hide();
            $("#editBtn").hide();
        });

    }

    componentWillUnmount(){
        $('.data-table-wrapper')
            .find('table')
            .DataTable()
            .destroy(true);
    }

    componentDidUpdate(oldProps) {
        if(this.props.companies !== oldProps.companies){
            reloadTableData(this.props.companies);
        }
    }

    render() {
        let modalAddNewOpen = (itemToEdit) => this.setState({ modalAddNewShow: true, selectedCompany:itemToEdit });
        let closeAddNewModal = () => this.setState({ modalAddNewShow: false });

        let modalConfirmDeleteOpen = (itemToEdit) => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();
            let data = table.rows( { selected: true }).data();

            this.setState({ modalConfirmDeleteShow: true });
        };
        let modalConfirmDeleteClose = () => this.setState({ modalConfirmDeleteShow: false });

        let deleteSelectedItemWithConfirmation = () => {
            modalConfirmDeleteOpen(null);
        };


        let editSelectedItem = () => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();
            let data = table.rows( { selected: true }).data();

            modalAddNewOpen(data[0]);

        };


        let deleteSelectedItem = () => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();

            let data = table.rows( { selected: true }).data();

            let IdCompany = data[0].IdCompany;

            serverService.deleteCompany(IdCompany).then(
                result => {
                    if(result.status == 1){
                        toast.success("Company deleted");
                        $("#deleteBtn").hide();
                        this.props.onCompanyDeleted();
                    } else {
                        toast.error("Delete failed");
                    }

                    this.setState({ modalConfirmDeleteShow: false });
                },
                error => {
                    toast.warn("Did not delete company");
                }
            );
        };


        return (
            <div className="row">
                <div  className="col-md-12" id="companiesTableContainer">

                    <table ref="main" className="table table-bordered companiesTable" />

                    <div className="float-right">

                        <ButtonToolbar>

                            <Button
                                id="editBtn"
                                variant="light"
                                onClick={editSelectedItem}
                            >
                                Edit
                            </Button>
                            &nbsp;
                            <Button
                                id="deleteBtn"
                                variant="light"
                                onClick={deleteSelectedItemWithConfirmation}
                            >
                                Delete
                            </Button>

                            &nbsp;

                            <Button
                                id="addBtn"
                                variant="light"
                                onClick={modalAddNewOpen}
                            >
                                Add
                            </Button>

                        </ButtonToolbar>

                    </div>

                    <AdminModalAddNewCompany
                        show={this.state.modalAddNewShow}
                        selectedCompany={this.state.selectedCompany}
                        onHide={closeAddNewModal}
                        onCompanyAdded={this.onCompanyAdded}
                        onCompanyEdited={this.onCompanyEdited}
                    />

                    <ModalConfirmAction
                        show={this.state.modalConfirmDeleteShow}
                        actionTitle="Confirm delete"
                        actionBody="Are you sure you want to delete the selected company?"
                        noBtnText="No, go back"
                        yesBtnText="Yes, confirm"
                        onConfirmNo={modalConfirmDeleteClose}
                        onHide={modalConfirmDeleteClose}
                        onConfirmYes={deleteSelectedItem}
                    />

                </div>

            </div>);
    }


    onCompanyAdded(item){
        this.props.onCompanyAdded(item);
        this.setState({modalAddNewShow: false});
    }

    onCompanyEdited(item){
        this.props.onCompanyEdited(item);
        this.setState({modalAddNewShow: false});
    }



    handleChange(e) {
        const { name, value } = e.target;
        let formFields = this.state.formFields;
        formFields[name] = value;
        this.setState({ formFields: formFields });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({submitted: true});

        const { formFields } = this.state;
        const Name = formFields.Name;

        // stop here if form is invalid
        if (!(Name)) {
            toast.error("Missing fields");
            return;
        }

        let company = {'IdCompany': '0', 'Name': Name };
        serverService.insertOrUpdateCompanyAdmin(company)
            .then(
                result => {
                    if(result.status == 1){
                        let messageStr = "Company added";
                        toast.success(messageStr);
                        this.props.onCompanyAdded(result.extra);

                        let formFields = this.state.formFields;
                        formFields.Name = "";
                        this.setState({ formFields: formFields });
                    } else {
                        toast.error("Add company failed");
                    }
                },
                error => {
                    toast.warn("Did not insert company");
                }
            );
    }
}

function reloadTableData(items) {
    const table = $('.data-table-wrapper')
        .find('table')
        .DataTable();
    table.clear();
    table.rows.add(items);
    table.draw();

    $("#deleteBtn").hide();
    $("#editBtn").hide();
}

export default AdminCompaniesTable;
